import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { getFocusRingStyle } from '@/src/components/focusring/focusring';
import { ChevronLeftIcon } from '@/src/components/icon/stroke/ChevronLeftIcon';
import { ChevronRightIcon } from '@/src/components/icon/stroke/ChevronRightIcon';
import { ChevronPreviousIcon } from '@/src/components/icon/stroke/ChevronPreviousIcon';
import { ChevronNextIcon } from '@/src/components/icon/stroke/ChevronNextIcon';
import { getInteractiveStyle } from '@/src/materialui/button/interactive';

export const flowPaginationItem: Components<Theme>['MuiPaginationItem'] = {
  defaultProps: {
    slots: {
      previous: ChevronLeftIcon,
      next: ChevronRightIcon,
      first: ChevronPreviousIcon,
      last: ChevronNextIcon,
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      margin: '0 4px',
      [theme.breakpoints.down('md')]: {
        margin: '0 2px',
      },
      // focused style
      ...getFocusRingStyle(theme),
      // custom font style from Figma
      '&.MuiButtonBase-root': {
        // interactive style
        ...getInteractiveStyle(
          {
            backgroundColor: 'transparent',
            fontWeight: '300',
            fontSize: '18px',
            letterSpacing: '0.36px',
            [theme.breakpoints.down('md')]: {
              fontSize: '16px',
            },
          },
          {
            backgroundColor: theme.palette.transparent.primary,
            fontWeight: '400',
            fontSize: '18px',
            letterSpacing: '0.36px',
            [theme.breakpoints.down('md')]: {
              fontSize: '16px',
            },
          },
        ),
      },
      color: theme.palette.text.primary,
      lineHeight: '24px',
      padding: '0',
      minWidth: '35px',
      height: '36px',
      position: 'relative',
      borderRadius: '4px',
      '& .MuiSvgIcon-root': {
        fontSize: '20px',
        [theme.breakpoints.down('md')]: {
          fontSize: '18px',
        },
      },
      '&.Mui-disabled': {
        color: theme.palette.disabled.primary,
        opacity: '1',
      },
      // style for ellipsis
      '&.MuiPaginationItem-ellipsis': {
        lineHeight: '36px',
        margin: '0 1px',
        pointerEvents: 'none',
      },
      // hide ellipsis for default (text) variant
      '&.MuiPaginationItem-text.MuiPaginationItem-ellipsis': {
        display: 'none',
      },
      // reset style for outlined variant
      '&.MuiPaginationItem-outlined': {
        border: '0',
      },
    }),
  },
};
